/**
 * Height of a single row in every virtualized list or table, in pixels.
 *
 * react-window needs the row height up front, so it cannot be derived from the
 * rendered content. Keep this value in sync with the row heights declared in
 * the stylesheets (`.listEntry`, `.virtualizedTable .row`, `.usersVirtuaList .col`).
 *
 * The sticky header of `VirtualizedTable` is exactly one row tall, so the same
 * value is used for the header offset.
 */
export const VIRTUALIZED_ROW_HEIGHT = 47;

/**
 * How many rows ahead of the viewport the InfiniteLoader starts fetching.
 */
export const VIRTUALIZED_LOADER_THRESHOLD = 40;

/**
 * react-window 2 requires a `rowProps` object. Our row components read their
 * data from a closure instead, so they need a stable empty object — an inline
 * `{}` would change identity on every render and defeat react-window's row
 * memoization.
 */
export const EMPTY_ROW_PROPS = {};
